/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AwsSsmExecutionStepBatchResponse {
    getFixupPrototypeFunction() { return AwsSsmExecutionStepBatchResponse.fixupPrototype; }

    static newInstance(model: Partial<AwsSsmExecutionStepBatchResponse>): AwsSsmExecutionStepBatchResponse {
        let obj = Object.assign(new AwsSsmExecutionStepBatchResponse(), model);
        AwsSsmExecutionStepBatchResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AwsSsmExecutionStepBatchResponse>): AwsSsmExecutionStepBatchResponse {
        if (!model) return null;
        return AwsSsmExecutionStepBatchResponse.newInstance(<AwsSsmExecutionStepBatchResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AwsSsmExecutionStepBatchResponse) {
        if (!obj) return;

        models.AwsSsmExecutionStepBatchResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AwsSsmExecutionStepBatchResponse): boolean {
        Object.setPrototypeOf(obj, AwsSsmExecutionStepBatchResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.results) {
            for (let key in this.results) {
                let val = this.results[key];
                if (val) {
                    models.AwsSsmStepExecution.fixupPrototype(val);
                }
            }
        }
    }

    /**
     * Map from identifier to response model
     */
    results: { [key: string]: models.AwsSsmStepExecution; };

}
